import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { LayerDTO, LayerTypeDTO, ScreenLayerDTO } from 'business/models/Models';
import { TreeService } from 'business/services/TreeService';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { TABLE_LAYOUT } from './ExperimentReportPDF';
import { getParentPath } from 'utils/Global';

export async function screenLayerSubReport(
  content: any[],
  expData: ExperimentDtoClient,
  screenDetail: boolean,
) {
  const screens = expData.layers.filter((lyr) => lyr.type === LayerTypeDTO.Screen);
  for (const scrn of screens) {
    const layer = scrn;
    content.push({
      text:
        '\n' + layer.name + ' - ' + (layer.height + 1) + ' x ' + (layer.width + 1) + '\n',
      style: 'largeText',
    });
    content.push(await getScreenLayerInfo(layer.layerDetail as ScreenLayerDTO));
    if (screenDetail) {
      content.push({ text: '\nScreen Conditions\n', style: 'largeText' });
      content.push(getScreenLayerDetailsTable(layer));
    }
  }
}

function getScreenLayerDetailsTable(layer: LayerDTO) {
  const lyrDetail = layer.layerDetail as ScreenLayerDTO;
  const maxConditions = (layer.height + 1) * (layer.width + 1);
  const body: any = [
    [
      { text: 'Condition #', bold: true },
      { text: 'Type', bold: true },
      { text: 'Ingredient Name', bold: true },
      { text: 'Stock Conc.', bold: true },
      { text: 'Stock Low pH', bold: true },
      { text: 'Stock High pH', bold: true },
      { text: 'Conc', bold: true },
      { text: 'pH', bold: true },
    ],
  ];
  let conditionNumber = 0;
  lyrDetail.screenLot.experiment.plateDto.forEach((p) =>
    p.ingredients.wellList.forEach((well) => {
      well.wellLayerList.forEach((wll) => {
        conditionNumber++;
        if (conditionNumber <= maxConditions) {
          wll.wellLayerIngredientList.forEach((ing) => {
            body.push([
              {
                text: conditionNumber,
                style: conditionNumber % 2 == 1 ? 'tableAltRow' : '',
              },
              {
                text: ing.ingredientTypeName,
                style: conditionNumber % 2 == 1 ? 'tableAltRow' : '',
              },
              {
                text: ing.ingredientStockIngredient.longName,
                style: conditionNumber % 2 == 1 ? 'tableAltRow' : '',
              },
              {
                text: ing.stockConcentration,
                style: conditionNumber % 2 == 1 ? 'tableAltRow' : '',
              },
              {
                text: ing.isBuffer ? ing.ingredientStock.stockPh : '',
                style: conditionNumber % 2 == 1 ? 'tableAltRow' : '',
              },
              {
                text:
                  ing.isBuffer && ing.highPhIngStock ? ing.highPhIngStock.stockPh : '',
                style: conditionNumber % 2 == 1 ? 'tableAltRow' : '',
              },
              {
                text: ing.concentration,
                style: conditionNumber % 2 == 1 ? 'tableAltRow' : '',
              },
              {
                text: ing.pH ? ing.pH : '',
                style: conditionNumber % 2 == 1 ? 'tableAltRow' : '',
              },
            ]);
          });
        }
      });
    }),
  );

  return {
    table: {
      widths: ['10%', '15%', '30%', '10%', '12%', '13%', '5%', '5%'],
      headerRows: 1,
      body: body,
    },
    layout: TABLE_LAYOUT,
  };
}

async function getScreenLayerInfo(lyrDetail: ScreenLayerDTO) {
  const treeService = new TreeService();
  const screenParents = await treeService.getDocumentParentNodes(
    lyrDetail.screenLot.id,
    ETreeNodeTypes.ScreenLot,
    true,
  );
  const screenPath = screenParents ? getParentPath(screenParents) : '';
  return {
    style: 'table',
    table: {
      widths: ['20%', '40%', '20%', '20%'],
      body: [
        [
          { text: 'Screen Lot Path', bold: true },
          { text: screenPath, colSpan: '3' },
          '',
          '',
        ],
        [
          { text: 'Screen Lot Name', bold: true },
          { text: screenParents.length >= 1 ? screenParents[0].name : '' },
          { text: 'Screen Volume', bold: true },
          { text: lyrDetail.volume },
        ],
        [
          { text: 'Screen Lot ID', bold: true },
          { text: lyrDetail.screenLot.id },
          { text: 'Screen Lot Dispense Volume', bold: true },
          { text: lyrDetail.screenLot.dispenseVolume },
        ],
        [
          { text: 'Lot Number', bold: true },
          { text: lyrDetail.screenLot.lotNumber },
          { text: 'Screen Lot Current Volume', bold: true },
          { text: lyrDetail.screenLot.currentVolume },
        ],
      ],
    },
    layout: TABLE_LAYOUT,
  };
}
